import { Dialog as UIDialog } from '@headlessui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

export const DialogTitle = UIDialog.Title;
export const DialogDescription = UIDialog.Description;

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const panelVariants = {
  hidden: { opacity: 0, x: '-100%' },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: '100%' },
};

export const Dialog = ({ isOpen, onClose, children, initialFocus }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <UIDialog
          as="div"
          static
          className="fixed z-50 inset-0 overflow-y-auto"
          open={isOpen}
          onClose={onClose}
          initialFocus={initialFocus}
        >
          <div className="min-h-screen text-center relative">
            {/* Backdrop */}
            <motion.div
              key="backdrop"
              className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md"
              variants={backdropVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              onClick={onClose}
            />

            {/* Spacer to center modal */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            {/* Panel */}
            <motion.div
              key="panel"
              className="inline-block align-middle  p-6 my-8 overflow-hidden text-left transform "
              variants={panelVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{
                duration: 0.6,
                ease: [0.25, 0.8, 0.25, 1], // custom cubic for ultra smooth
              }}
            >
              {children}
            </motion.div>
          </div>
        </UIDialog>
      )}
    </AnimatePresence>
  );
};

Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  initialFocus: PropTypes.object,
};
